import mediaVendorService from "../../services/vendormediaamend";
import lookerService from "../../services/looker";
const getDefaultState = () => {
    return {
        EditFormData: null,
        MediaVendorAmend: {
            BankName: null,
            BankBIC: null,
            BankIBAN: null,
            SelectedCountryName: "",
            BankCountry: null,
            BankState: null,
            SelectedStateName: null,
            BankCity: null,
            BankZipCode: null,
            AccountName: null,
            AccountNumber: null,
            RoutingNumber: null,
            DunAndBradstreetNumber: null,
            AccountingEmailAddress: null,
            AccountingPhone: null,
            AccountingContactName: null,
            AccountingContactTitle: null,
            InfoFromTitle: null,
            InfoFromName: null,
            InfoFromPhone: null,
            VendorRemittanceName: null,
            VendorCode: null,
            VendorTypeCode: null,
            MediaRepCode: null,
            MediaRepName: null,
            VendorTypeSystem: null,
            VendorTypeMedia: null,
            IsRemittanceNameAddressChanged: null,
            IsBankingInfoChanged: null,
            BankAddressLine1: null,
            BankAddressLine2: null,
            VendorType: null,
            ID: 0,
            IsCreditCardAccepted: null,
            AreThereConditionsOrLimitations: null,
            VendorBusinessName: null,
            IdentificationOption: null,
            VendorInvoiceCopyFiles: [],
            IdentificationType: null,
            USTaxId: null,
            Foreign: null,
            SocialSecurityNumber: null,
            IdentificationFiles: [],
            RemittanceAdviceEmail: null,
            SampleMediaKitFiles: [],
            EmployeePhoneNumber: null,
            EmployeeAgency: null,
            AgencyName: null,
            VendorName: "",
            Attestation: null,
            AnyGiftOrCompensationOfferedToYouToPlaceOrder: null,
            CompensationReceived: null,
            EmployeeVendorRelationshipDetails: {
                FormerEmployeeName: null,
                FamilyMemberName: null,
                FriendName: null,
                VendorRelationshipWithAgencyClient: null,
                VendorOfFormerEmployee: null,
                VendorWasFormerEmployeeOfAgency: null,
                VendorHasRelationshipWithAnotherAgencyEmployee: null,
                Other: null,
                VendorMediaAmendRequestId: 0,
                ID: 0,
            },
            EmployeeVendorRelationship: [],
            // MediaTypes: [],
            MediaType: null, //for normal select ion
            EmployeeRelationships: [],
            Requestor: null,
            IsEditDataLoaded: false,
            Status: null,
            InvoiceAttachment: [],
            BankLetter: [],
            IsMediaRepRequest: null,
            CreditLimitation: null,
            ChangeType: null,
            RemittanceCountry: null,
            StreetAddressLine1: null,
            RemittanceCity: null,
            RemittanceState: null,
            RemittanceZipCode: null,
            IsACHPayment: null,
            IsBankingInfoCollected: null,
            CreditCardFiles: [],
            HasBankLetterInvoice: null,
            HasACHPaymentSetup: null,
            Entity: null,
            EntityName: null,
            CompletedForms: [],
            IsBankingInfoAppear: null,
            VendorWirePaymentBankLetter: [],
            IsPaidByWire: null,
            VendorConfirmationEmail: [],
            BankingInfoInvoiceAttachment: [],
            InfoFromVendorEmail: null,
        },
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    MediaVendorAmend: (state) => {
        return state.MediaVendorAmend;
    },
    SubmittedFormData: (state) => {
        return state.EditFormData;
    },
};

// actions
const actions = {
    async GetFormData(st, id) {
        await mediaVendorService
            .GetFormData(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);
                return res.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    GetDraftFormData(st, id) {
        return mediaVendorService.GetDraftFormData(id, st.rootState.auth.idToken);
    },
    GetRequestWithTaskDetails(st, id) {
        return mediaVendorService.GetRequestWithTaskDetails(
            id,
            st.rootState.auth.idToken
        );
    },
    AddRequest(st, data) {
        return mediaVendorService.AddRequest(data, st.rootState.auth.idToken);
    },
    AddRequestWithFiles(st, data) {
        return mediaVendorService.AddRequestWithFiles(
            data,
            st.rootState.auth.idToken
        );
    },
    ApproveRequestLevel1(st, data) {
        return mediaVendorService.ApproveRequestLevel1(
            data,
            st.rootState.auth.idToken
        );
    },
    ApproveRequestLevel2(st, data) {
        return mediaVendorService.ApproveRequestLevel2(
            data,
            st.rootState.auth.idToken
        );
    },
    AccountingApprove(st, data) {
        return mediaVendorService.AccountingApprove(
            data,
            st.rootState.auth.idToken
        );
    },
    CFOApprove(st, data) {
        return mediaVendorService.CFOApprove(
            data,
            st.rootState.auth.idToken
        );
    },
    CompleteVendorRequest(st, data) {
        return mediaVendorService.CompleteVendorRequest(
            data,
            st.rootState.auth.idToken
        );
    },
    RejectRequestLevel1(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "RejectLevel1"
        );
    },
    RejectRequestLevel2(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "RejectLevel2"
        );
    },
    RejectVendorValidation(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "RejectVendorValidation"
        );
    },
    AccountingReject(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "AccountingReject"
        );
    },
    CFOReject(st, data) {
        return mediaVendorService.RejectRequest(
            data,
            st.rootState.auth.idToken,
            "CFOReject"
        );
    },
    GetRequests(st, options) {
        return mediaVendorService.GetRequests(st.rootState.auth.idToken, options);
    },
    RenderUploadedFiles(st, { id, category }) {
        return mediaVendorService.RenderUploadedFiles(
            st.rootState.auth.idToken,
            id,
            category
        );
    },
    UpdateRequestWithFiles(st, { id, data }) {
        return mediaVendorService.UpdateRequestWithFiles(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetUsers(st, { agencyName, name }) {
        return mediaVendorService.GetUsers(
            st.rootState.auth.idToken,
            agencyName,
            name
        );
    },
    SaveAsDraft(st, data) {
        return mediaVendorService.SaveAsDraft(data, st.rootState.auth.idToken);
    },
    GetAuditFormData(st, id) {
        return mediaVendorService.GetAuditFormData(id, st.rootState.auth.idToken);
    },
    GetSystemDropdown(st, data) {
        return lookerService.GetSystemDropdown(st.rootState.auth.idToken, data);
    },
    GetMediaDropdown(st, data) {
        return lookerService.GetMediaDropdown(st.rootState.auth.idToken, data);
    },
    GetCodeDropdown(st, data) {
        return lookerService.GetCodeDropdown(st.rootState.auth.idToken, data);
    },
    GetWorkflowStates(st, id) {
        return mediaVendorService.GetWorkflowStates(id, st.rootState.auth.idToken);
    },
    GetWorkflowHistoryStates(st, id) {
        return mediaVendorService.GetWorkflowHistoryStates(
            id,
            st.rootState.auth.idToken
        );
    },
    PendingVendorApproveorComplete(st, data) {
        return mediaVendorService.PendingVendorApproveorComplete(
            data,
            st.rootState.auth.idToken
        );
    },
    SaveRequestAsDraft(st, draftRequestId) {
        var DraftObj = {};
        DraftObj.DraftRequestID =
            draftRequestId != null && !isNaN(draftRequestId) ?
            parseInt(draftRequestId) :
            null;
        DraftObj.EmployeePhoneNumber = st.getters.MediaVendorAmend.EmployeePhoneNumber;
        DraftObj.Entity = st.getters.MediaVendorAmend.Entity;
        DraftObj.EmployeeAgency = st.getters.MediaVendorAmend.EmployeeAgency;
        DraftObj.AgencyName = st.getters.MediaVendorAmend.AgencyName;
        DraftObj.VendorTypeSystem = st.getters.MediaVendorAmend.VendorTypeSystem;
        DraftObj.VendorTypeMedia = st.getters.MediaVendorAmend.VendorTypeMedia;
        DraftObj.MediaRepCode = st.getters.MediaVendorAmend.MediaRepCode;
        DraftObj.MediaRepName = st.getters.MediaVendorAmend.MediaRepName;
        DraftObj.VendorTypeCode = st.getters.MediaVendorAmend.VendorTypeCode;
        DraftObj.IsRemittanceNameAddressChanged = st.getters.MediaVendorAmend.IsRemittanceNameAddressChanged;
        DraftObj.IsBankingInfoChanged = st.getters.MediaVendorAmend.IsBankingInfoChanged;
        DraftObj.Files = [];
        let CompletedForms = st.getters.MediaVendorAmend.CompletedForms;
        if (CompletedForms != null && CompletedForms.length > 0) {
            CompletedForms.forEach(completedForm => {
                DraftObj.Files.push({ Category: `CompletedForms`, Name: completedForm.Name || completedForm.name })
            });
        }
        DraftObj.VendorCode = st.getters.MediaVendorAmend.VendorCode;
        DraftObj.VendorBusinessName = st.getters.MediaVendorAmend.VendorBusinessName;

        let InvoiceAttachment = st.getters.MediaVendorAmend.InvoiceAttachment;
        if (InvoiceAttachment != null && InvoiceAttachment.length > 0) {
            InvoiceAttachment.forEach(invoiceAttachment => {
                DraftObj.Files.push({ Category: `InvoiceAttachment`, Name: invoiceAttachment.Name || invoiceAttachment.name })
            });
        }
        DraftObj.VendorRemittanceName = st.getters.MediaVendorAmend.VendorRemittanceName;

        let VendorWirePaymentBankLetter = st.getters.MediaVendorAmend.VendorWirePaymentBankLetter;
        if (VendorWirePaymentBankLetter != null && VendorWirePaymentBankLetter.length > 0) {
            VendorWirePaymentBankLetter.forEach(vendorWirePaymentBankLetter => {
                DraftObj.Files.push({ Category: `VendorWirePaymentBankLetter`, Name: vendorWirePaymentBankLetter.Name || vendorWirePaymentBankLetter.name })
            });
        }

        DraftObj.StreetAddressLine1 = st.getters.MediaVendorAmend.StreetAddressLine1;
        DraftObj.StreetAddressLine2 = st.getters.MediaVendorAmend.StreetAddressLine2;
        DraftObj.RemittanceCountry = st.getters.MediaVendorAmend.RemittanceCountry;
        DraftObj.RemittanceCity = st.getters.MediaVendorAmend.RemittanceCity;
        DraftObj.RemittanceState = st.getters.MediaVendorAmend.RemittanceState;
        DraftObj.RemittanceZipCode = st.getters.MediaVendorAmend.RemittanceZipCode;
        DraftObj.AccountingContactName = st.getters.MediaVendorAmend.AccountingContactName;
        DraftObj.AccountingContactTitle = st.getters.MediaVendorAmend.AccountingContactTitle;
        DraftObj.AccountingPhone = st.getters.MediaVendorAmend.AccountingPhone;
        DraftObj.AccountingEmailAddress = st.getters.MediaVendorAmend.AccountingEmailAddress;
        DraftObj.InfoFromName = st.getters.MediaVendorAmend.InfoFromName;
        DraftObj.InfoFromTitle = st.getters.MediaVendorAmend.InfoFromTitle;
        DraftObj.InfoFromPhone = st.getters.MediaVendorAmend.InfoFromPhone;
        DraftObj.InfoFromVendorEmail = st.getters.MediaVendorAmend.InfoFromVendorEmail;
        DraftObj.IdentificationType = st.getters.MediaVendorAmend.IdentificationType;
        DraftObj.USTaxId = st.getters.MediaVendorAmend.USTaxId;
        DraftObj.Foreign = st.getters.MediaVendorAmend.Foreign;
        DraftObj.SocialSecurityNumber = st.getters.MediaVendorAmend.SocialSecurityNumber;

        let IdentificationFiles = st.getters.MediaVendorAmend.IdentificationFiles;
        if (IdentificationFiles != null && IdentificationFiles.length > 0) {
            IdentificationFiles.forEach(identificationFile => {
                DraftObj.Files.push({ Category: `IdentificationFiles`, Name: identificationFile.Name || identificationFile.name })
            });
        }

        DraftObj.DunAndBradstreetNumber = st.getters.MediaVendorAmend.DunAndBradstreetNumber;
        DraftObj.CreditLimitation = st.getters.MediaVendorAmend.CreditLimitation;

        let VendorConfirmationEmail = st.getters.MediaVendorAmend.VendorConfirmationEmail;
        if (VendorConfirmationEmail != null && VendorConfirmationEmail.length > 0) {
            VendorConfirmationEmail.forEach(vendorConfirmationEmail => {
                DraftObj.Files.push({ Category: `VendorConfirmationEmail`, Name: vendorConfirmationEmail.Name || vendorConfirmationEmail.name })
            });
        }

        let CreditCardFiles = st.getters.MediaVendorAmend.CreditCardFiles;
        if (CreditCardFiles != null && CreditCardFiles.length > 0) {
            CreditCardFiles.forEach(creditCardFile => {
                DraftObj.Files.push({ Category: `CreditCardFiles`, Name: creditCardFile.Name || creditCardFile.name })
            });
        }

        let BankingInfoInvoiceAttachment = st.getters.MediaVendorAmend.BankingInfoInvoiceAttachment;
        if (BankingInfoInvoiceAttachment != null && BankingInfoInvoiceAttachment.length > 0) {
            BankingInfoInvoiceAttachment.forEach(bankingInfoInvoiceAttachment => {
                DraftObj.Files.push({ Category: `BankingInfoInvoiceAttachment`, Name: bankingInfoInvoiceAttachment.Name || bankingInfoInvoiceAttachment.name })
            });
        }
        DraftObj.BankName = st.getters.MediaVendorAmend.BankName;
        DraftObj.BankCountry = st.getters.MediaVendorAmend.BankCountry;
        DraftObj.BankAddressLine1 = st.getters.MediaVendorAmend.BankAddressLine1;
        DraftObj.BankAddressLine2 = st.getters.MediaVendorAmend.BankAddressLine2;
        DraftObj.BankCity = st.getters.MediaVendorAmend.BankCity;
        DraftObj.BankState = st.getters.MediaVendorAmend.BankState;
        DraftObj.BankZipCode = st.getters.MediaVendorAmend.BankZipCode;
        DraftObj.AccountName = st.getters.MediaVendorAmend.AccountName;
        DraftObj.AccountNumber = st.getters.MediaVendorAmend.AccountNumber;
        DraftObj.RoutingNumber = st.getters.MediaVendorAmend.RoutingNumber;
        DraftObj.BankBIC = st.getters.MediaVendorAmend.BankBIC;
        DraftObj.BankIBAN = st.getters.MediaVendorAmend.BankIBAN;
        DraftObj.RemittanceAdviceEmail = st.getters.MediaVendorAmend.RemittanceAdviceEmail;

        let BankLetter = st.getters.MediaVendorAmend.BankLetter;
        if (BankLetter != null && BankLetter.length > 0) {
            BankLetter.forEach(bankLetter => {
                DraftObj.Files.push({ Category: `BankLetter`, Name: bankLetter.Name || bankLetter.name })
            });
        }
        DraftObj.EmployeeVendorRelationship =
            (st.getters.MediaVendorAmend.EmployeeVendorRelationship || []).map(name => ({
                ID: 0,
                RelationshipName: name
            }));
        DraftObj.EmployeeVendorRelationshipDetails = st.getters.MediaVendorAmend.EmployeeVendorRelationshipDetails;
        DraftObj.EmployeeVendorRelationshipDetails.ID = 0;
        DraftObj.CompensationReceived = st.getters.MediaVendorAmend.CompensationReceived;
        const draftFieldsToConvert = [
            "IsMediaRepRequest",
            "IsBankingInfoAppear",
            "IsPaidByWire",
            "IdentificationOption",
            "IsCreditCardAccepted",
            "AreThereConditionsOrLimitations",
            "HasACHPaymentSetup",
            "HasBankLetterInvoice",
            "IsACHPayment",
            "IsBankingInfoCollected",
            "AnyGiftOrCompensationOfferedToYouToPlaceOrder",
        ];
        draftFieldsToConvert.forEach(field => {
            DraftObj[field] = st.getters.MediaVendorAmend[field];
            if (st.getters.MediaVendorAmend[field] === "true") {
                DraftObj[field] = true;
            } else if (st.getters.MediaVendorAmend[field] === "false") {
                DraftObj[field] = false;
            } else {
                DraftObj[field] = null;
            }
        });
        console.log(DraftObj, "DraftObj")
        console.log(JSON.stringify(DraftObj), "DraftObj")
        let formData = new FormData();
        formData.append("request", JSON.stringify(DraftObj));
        for (let i = 0; i < BankLetter.length; i++) {
            let file = BankLetter[i];
            formData.append(`BankLetter`, file.file);
        }
        for (let j = 0; j < BankingInfoInvoiceAttachment.length; j++) {
            let file = BankingInfoInvoiceAttachment[j];
            formData.append(`BankingInfoInvoiceAttachment`, file.file);
        }
        for (let k = 0; k < CreditCardFiles.length; k++) {
            let file = CreditCardFiles[k];
            formData.append(`CreditCardFiles`, file.file);
        }
        for (let l = 0; l < VendorConfirmationEmail.length; l++) {
            let file = VendorConfirmationEmail[l];
            formData.append(`VendorConfirmationEmail`, file.file);
        }
        for (let n = 0; n < IdentificationFiles.length; n++) {
            let file = IdentificationFiles[n];
            formData.append(`IdentificationFiles`, file.file);
        }
        for (let o = 0; o < VendorWirePaymentBankLetter.length; o++) {
            let file = VendorWirePaymentBankLetter[o];
            formData.append(`VendorWirePaymentBankLetter`, file.file);
        }
        for (let p = 0; p < InvoiceAttachment.length; p++) {
            let file = InvoiceAttachment[p];
            formData.append(`InvoiceAttachment`, file.file);
        }
        for (let p = 0; p < CompletedForms.length; p++) {
            let file = CompletedForms[p];
            formData.append(`CompletedForms`, file.file);
        }
        return mediaVendorService.SaveRequestAsDraft(st.rootState.auth.idToken, formData);
    },
    GetDraftRequest(st, id) {
        mediaVendorService
            .GetDraftRequest(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);
                return res.data;
            })
            .catch((error) => {
                return error;
            });
    },
    DeleteDraft(st, id) {
        return mediaVendorService.DeleteDraft(st.rootState.auth.idToken, id);
    },
};

function GetFilesCategory() {
    return ["IdentificationFiles", "BankLetter", "InvoiceAttachment", "CreditCardFiles", "CompletedForms", "VendorWirePaymentBankLetter", "VendorConfirmationEmail", "BankingInfoInvoiceAttachment"];
}
// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
    loadVendorData(state, data) {
        // state.MediaVendorAmend = data;
        Object.assign(state.MediaVendorAmend, data);
        if (state.MediaVendorAmend.EmployeeVendorRelationship != null) {
            state.MediaVendorAmend.EmployeeVendorRelationship = state.MediaVendorAmend.EmployeeVendorRelationship.map(
                (name) => name.RelationshipName
            );
        }
        state.MediaVendorAmend.IsEditDataLoaded = false;
        state.MediaVendorAmend.InfoFromName = data.InfoFromName;
        state.MediaVendorAmend.InfoFromTitle = data.InfoFromTitle;
        state.MediaVendorAmend.InfoFromPhone = data.InfoFromPhone;
        state.MediaVendorAmend.InfoFromVendorEmail = data.InfoFromVendorEmail;
        state.MediaVendorAmend.Entity = data.Entity;
        state.MediaVendorAmend.EmployeeAgency = data.EmployeeAgency;
        state.MediaVendorAmend.AgencyName = "";
        state.MediaVendorAmend.SelectedCountryName = "";
        state.MediaVendorAmend.IdentificationFiles = [];
        state.MediaVendorAmend.BankLetter = [];
        state.MediaVendorAmend.CreditCardFiles = [];
        state.MediaVendorAmend.InvoiceAttachment = [];
        state.MediaVendorAmend.CompletedForms = [];
        state.MediaVendorAmend.VendorWirePaymentBankLetter = [];
        state.MediaVendorAmend.VendorConfirmationEmail = [];
        state.MediaVendorAmend.BankingInfoInvoiceAttachment = [];
        const fieldsToConvert = [
            "IsPaidByWire",
            "IsCreditCardAccepted",
            "IdentificationOption",
            "AreThereConditionsOrLimitations",
            "HasACHPaymentSetup",
            "HasBankLetterInvoice",
            "IsACHPayment",
            "IsBankingInfoCollected",
            "IsBankingInfoAppear",
            "AnyGiftOrCompensationOfferedToYouToPlaceOrder",
            "IsMediaRepRequest",
        ];
        fieldsToConvert.forEach(field => {
            if (data[field] === true) {
                state.MediaVendorAmend[field] = "true";
            } else if (data[field] === false) {
                state.MediaVendorAmend[field] = "false";
            } else {
                state.MediaVendorAmend[field] = null;
            }
        });
        if (state.MediaVendorAmend.IsMediaRepRequest === true || state.MediaVendorAmend.IsMediaRepRequest === 'true') {
            state.MediaVendorAmend.MediaRepCode = data.VendorTypeCode
        }
    },
    loadVendorFiles(state, data) {
        if (data.Files.length > 0) {
            GetFilesCategory().forEach((file) => {
                if (typeof file == "undefined" || file == null) {
                    return;
                } else {
                    let files = data.Files.filter((catFile) => {
                        return catFile.Category == file;
                    });
                    if (files.length > 0) {
                        files.forEach((originalFile) => {
                            state.MediaVendorAmend[file].push(originalFile);
                        });
                    }
                }
            });
        }
        state.MediaVendorAmend.IsEditDataLoaded = true;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};